import { render, staticRenderFns } from "./index.vue?vue&type=template&id=503da8ce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=503da8ce&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503da8ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('503da8ce')) {
      api.createRecord('503da8ce', component.options)
    } else {
      api.reload('503da8ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=503da8ce&scoped=true", function () {
      api.rerender('503da8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/navBars/breadcrumb/index.vue"
export default component.exports